import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

// TODO: Experience
// main work cards
function ExperienceCard(props: any) {
  return (
    <div className="experience-card">
      <h1 className="title">Software developer intern</h1>
      <a href={props.link} className="company">
        {props.company}
      </a>
      <p className="activities">
        {props.activities} <br />
      </p>
      <p className="date">{props.date}</p>
    </div>
  );
}
function Card(props: any) {
  return (
    <div className="main-work__card">
      <img loading="lazy" src={props.src} alt={props.alt} />
      <h1 className="title">{props.title.toUpperCase()}.</h1>
      <h2 className="description">{props.description}.</h2>
      <div className="main-work__links">
        <a
          href={props.site}
          target="_blank"
          rel="noreferrer"
          className="site-link"
        >
          Check It Out
        </a>
        <a
          href={props.github}
          target="_blank"
          rel="noreferrer"
          className="github-link"
        >
          Github Link
        </a>
      </div>
    </div>
  );
}
// sub work cards
function SubCard(props: any) {
  return (
    <div className="sub-work__card">
      <div className="links">
        <a
          href={props.github}
          target="_blank"
          rel="noreferrer"
          className="github"
        >
          <FontAwesomeIcon icon={faGithub} />
        </a>
        {/* <a
          href={props.externalLink}
          target="_blank"
          rel="noreferrer"
          className="external-link"
        >
          <FontAwesomeIcon icon={faUpRightFromSquare} />
        </a> */}
        <h1>{props.title.toUpperCase()}.</h1>
        <p>{props.description}.</p>
      </div>
    </div>
  );
}
function Work() {
  return (
    <div className="work" id="work">
      <div className="container">
        <div className="work-content">
          <h1 className="about-header">Work Experience</h1>

          <div className="experience">
            <ExperienceCard
              link="https://noma.co.ke/"
              company="NoMa SRS"
              date="November 2024 to April 2025"
              activities="I developed an admin panel using filamentphp and laravel for the company"
            />
            <ExperienceCard
              link="https://artemisys.tech/"
              company="Artemis systems"
              date="August 2023 to December 2023"
              activities="Created a point of sale using Nuxtjs and Nestjs "
            />
            <ExperienceCard
              link="https://www.vintextechnologies.com/"
              company="Vintex technologies"
              date="January 2023 to March 2023"
              activities="Created the fronted, backend and admin panel of an e-commerce website using Vue and Express"
            />
          </div>
          <h2 className="about-header">Some Things I've Built.</h2>
          <div className="main-work">
            <Card
              src="img4.png"
              alt="Machakos Uni students App"
              title="Machakos Uni students App"
              description="An android app for Machakos university students with over 5k downloads in the google playstore"
              site="https://play.google.com/store/apps/details?id=com.michael.machakos"
              github="https://github.com/michaelnjuguna/Machakos-university-app"
            />
            <Card
              src="img2.PNG"
              alt="VENDING MACHINES MANUFACTURER"
              title="vendor machine manufacturer"
              description="I built this project for my brother who had started a business of selling vending machines"
              site="https://vendingmachinemanufactures.netlify.app/"
              github="https://github.com/michaelnjuguna/Vendor-machine-manufactures"
            />
            <Card
              src="img3.PNG"
              alt="legit Movers"
              title="legit movers limited"
              description="This business website is for a movers company"
              site="https://legit-movers-group.netlify.app/"
              github="https://github.com/michaelnjuguna/legit-movers"
            />
          </div>
          <h2 className="about-sub__header">Other Open source Projects.</h2>
          <div className="sub-work">
            <SubCard
              github="https://github.com/michaelnjuguna/kenya-administrative-divisions"
              title="Kenya administrative divisions"
              description="An npm package to get information about kenya administrative divisions i.e Counties. With over 15 stars on github"
            />
            <SubCard
              github="https://github.com/michaelnjuguna/Kenyan-counties-their-subcounties-and-wards-in-json-yaml-mysql-csv-latex-xlsx-Bson-markdown-and-xml"
              title="Phpmon"
              description="A CLI tool to monitor and restart PHP scripts"
            />
            <SubCard
              github="https://github.com/michaelnjuguna/All-swahili-words-dictionary"
              title="Kenyan administrative information"
              description="All Kenyan counties, their subcounties and wards in json, yaml, mysql,csv,latex,xlsx,Bson,&nbsp; markdown and xml."
            />
          </div>
          <div className="work-links">
            <h3 className="about-work">
              Check out all my code and projects{" "}
              <a
                href="https://github.com/michaelnjuguna?tab=repositories"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>{" "}
              .
            </h3>
            <h3 className="about-work">
              Check out all my mobile apps{" "}
              <a
                href="https://play.google.com/store/apps/developer?id=michael+njuguna"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>{" "}
              .
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
